import script from "./ThumbnailComponentDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./ThumbnailComponentDelete.vue?vue&type=script&setup=true&lang=js"

import "./ThumbnailComponentDelete.vue?vue&type=style&index=0&id=4bfbc2f3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bfbc2f3"]])

export default __exports__